<template>
  <div id="app">
    <SiteHeader/>
    <router-view class="puHuiTi-Medium"></router-view>
    <SiteFooter/>

  </div>
</template>
<script>
import SiteHeader from './components/SiteHeader.vue' // 引入 Header 组件
import SiteFooter from './components/SiteFooter.vue' // 引入 Header 组件

let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
link.type = "image/x-icon";
link.rel = "shortcut icon";
link.href = require(`@/assets/img/logo_site.png`)
document.getElementsByTagName("head")[0].appendChild(link);


export default {
  components:{
    SiteHeader,
    SiteFooter
  },
  data(){

  },
  methods:{

  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
*{
    margin: 0;
    padding: 0;
}
html{
  font-size: 1vw;
}



</style>